export default __webpack_public_path__ + "static/media/img.5bb33a5d.png";